import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { noexam } from "../../../assets";
import { FaAngleLeft } from "react-icons/fa";
import Loading from "../../../components/common/Loading";
import Footer from "../../../components/home/common/Footer";
import ExamHeader from "../../../components/home/examPage/ExamHeader";
import {
  getDynamicQuestion,
  getDynamicExamError,
  getDynamicExamQuestion,
  getDynamicExamStatus,
  resetDynamicExam,
} from "../../../redux/slice/dynamicExamSlice";

import DynamicExamForm from "../../../components/home/dynamicExam/DynamicExamForm";
import { useNavigate, useParams } from "react-router-dom";

const DynamicExamMain = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const examId = useParams().examId;

  const examStatus = useSelector(getDynamicExamStatus);
  const examError = useSelector(getDynamicExamError);
  const question = useSelector(getDynamicExamQuestion);

  useEffect(() => {
    if (!question) {
      dispatch(getDynamicQuestion(examId));
    }
    return () => {
      dispatch(resetDynamicExam());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className=" sm:p-6 sm:pb-3 p-3 bg-[#FBF9F9] flex flex-col justify-start gap-6 min-h-[100vh]">
      {examStatus === "loading" ? <Loading /> : null}
      <ExamHeader />
      {/* {examError ? <AlertBox type="failed" message={examError} /> : null} */}
      <section className="self-center flex flex-col sm:w-[700px] w-[95%] bg-white sm:p-8 p-3 sm:rounded-[30px] rounded-md shadow-md gap-3">
        {examError ? (
          <div className="flex flex-col justify-center items-center gap-4">
            <button
              onClick={handleBack}
              className="self-start flex justify-center items-center max-w-[100px]"
            >
              <FaAngleLeft className="text-textPrimary" />
              <span className="text-textPrimary font-semibold pl-1">Back</span>
            </button>
            <p className="font-medium text-[18px] text-red-500 italic">
              No Question found for this topic. Please select another one.
            </p>
            <img src={noexam} alt="" className="" />
          </div>
        ) : (
          <DynamicExamForm />
        )}
      </section>

      <Footer />
    </div>
  );
};

export default DynamicExamMain;
